import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
const faqs = [{
  q: '¿Sirve si recién estoy comenzando?',
  a: 'Sí. Precisamente una de sus principales ventajas es ofrecerte una estructura desde las primeras sesiones.'
}, {
  q: '¿Sirve si ya tengo experiencia?',
  a: 'Sí. El objetivo no es reemplazar tu formación, sino ayudarte a organizar y consultar rápidamente herramientas prácticas.'
}, {
  q: '¿Es un curso?',
  a: 'No. Es una biblioteca digital de Tomos, guías, fichas y herramientas de consulta.'
}, {
  q: '¿Necesito imprimirlo?',
  a: 'No. Puedes utilizarlo desde celular, tablet o computadora. Las fichas que quieras completar manualmente también pueden imprimirse.'
}, {
  q: '¿Puedo utilizar los documentos legales en cualquier país?',
  a: 'Son modelos educativos. La legislación y los requisitos profesionales cambian según cada país, por lo que deben adaptarse y, cuando corresponda, revisarse con un profesional local.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Digitalmente, utilizando el correo registrado durante la compra.'
}, {
  q: '¿Tengo acceso permanente?',
  a: 'Sí. La compra es de pago único.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-86" data-mp="1fn2iq6urhqw2">
      <div className="mb-10 text-center" data-id="element-87" data-mp="11x8spl7it0kr">
        <h2 className="flex justify-center font-display text-2xl font-bold text-brand-blue md:text-4xl" data-id="element-88" data-mp="11w7fba3181zv">
          <span className="mr-3" data-id="element-89" data-mp="16oqsw71pyx4o">❓</span>PREGUNTAS FRECUENTES
        </h2>
      </div>
      <div className="space-y-4" data-id="element-90" data-mp="rzufdugw8rwo">
        {faqs.map((faq, index) => <div key={faq.q} className="paper-panel overflow-hidden rounded-2xl border-l-4 border-l-brand-blueMid" data-id="element-91" data-mp="wy5m3wbw6mao" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-brand-parchment focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-amber" data-id="element-92" data-mp="iymt6arnjhiy">
              <span className="pr-8 text-sm font-semibold text-brand-blue md:text-base" data-id="element-93" data-mp="2kuc5autqwc84">{faq.q}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-goldDark transition-transform duration-200 ease-out ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-94" data-mp="2fxd8g4ip5r68" />
            </button>
            <AnimatePresence initial={false} data-id="element-95" data-mp="38k6cavrdv6kg">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-96" data-mp="33m4x4lx2vre9">
                  <p className="border-t border-brand-blue/10 bg-white px-6 py-4 text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-97" data-mp="1n9psx3wa9qqg">
                    {faq.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}